module.exports = __webpack_public_path__ + "static/img/TN.7247ac60.png";